var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.getComponent(),{tag:"component",attrs:{"goods":_vm.goods},on:{"updata":_vm.updata}})
}
var staticRenderFns = []

export { render, staticRenderFns }